export default {
  edit_selection: 'Editar selección',
};
